import React, { useState, useEffect, useRef } from "react";
import "./WelcomeSection.css";
import MetalPrint from "../../Gallery/metal-3d-printing-part-1-1.webp";

function WelcomeSection() {
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const sectionRef = useRef(null);

  const handleMouseMove = (e) => {
    const { clientX, clientY } = e;
    const x = (window.innerWidth / 2 - clientX) / 25;
    const y = (window.innerHeight / 2 - clientY) / 25;
    setOffset({ x, y });
  };

  useEffect(() => {
    const section = sectionRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) section.classList.add("ws_show");
        else section.classList.remove("ws_show");
      },
      { threshold: 0.3 }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="ws_section"
      ref={sectionRef}
      onMouseMove={handleMouseMove}
    >
      <div id="ws_container">

        {/* TEXT CONTENT */}
        <div id="ws_left">

          <div id="ws_topline" className="ws_item ws_d1">
            <span id="ws_line"></span>
            <span id="ws_label">Next-Gen Engineering</span>
          </div>

          <h2 id="ws_heading" className="ws_item ws_d2">
            Engineering the <br />
            <span id="ws_gradient">Future of Spares.</span>
          </h2>

          <p id="ws_desc" className="ws_item ws_d3">
            VB SHAH INC specializes in high-precision <strong>Metal 3D Printing</strong> 
            and advanced tooling. We turn complex digital geometries into 
            high-strength industrial components with zero compromise on quality.
          </p>

          <div id="ws_stats" className="ws_item ws_d4">
            <div className="ws_stat">
              <h4>99.9%</h4>
              <p>Precision Accuracy</p>
            </div>
            <div className="ws_stat">
              <h4>24/7</h4>
              <p>Rapid Prototyping</p>
            </div>
          </div>

          <button id="ws_cta" className="ws_item ws_d5">
            <span>Our Process</span>
            <div id="ws_dot"></div>
          </button>
        </div>

        {/* RIGHT VISUAL */}
        <div id="ws_right" className="ws_item ws_d3">
          <div id="ws_backdrop"></div>

          <div
            id="ws_floatwrap"
            style={{ transform: `translate(${offset.x}px, ${offset.y}px)` }}
          >
            <img src={MetalPrint} alt="Metal Part" id="ws_img" />
          </div>

          <div id="ws_tag1" className="ws_item ws_d4">STAINLESS STEEL 316L</div>
          <div id="ws_tag2" className="ws_item ws_d5">DMLS TECHNOLOGY</div>
        </div>

      </div>
    </section>
  );
}

export default WelcomeSection;
